import React, { useState } from "react";
import TwoButton from "../TwoButton";
import Modal from "../styled/Modal/Modal";
import Flexible from "./Flexible";
import Locked from "./Locked";

function Stake(props) {
  const [current, setCurrent] = useState("flexible");
  const [childloading, setChildLoading] = useState(false);

  const startLoading = () => {
    setChildLoading(true);
  };

  const stopLoading = () => {
    setChildLoading(false);
  };

  return (
    <Modal centered modal {...props} backdrop={childloading ? "static" : true}>
      <div className="py-2">
        <TwoButton
          current={current}
          modal={true}
          buttons={[
            {
              name: "Flexible",
              onClick: (id) => setCurrent(id),
              identifier: "flexible",
            },
            {
              name: "Locked",
              onClick: (id) => setCurrent(id),
              identifier: "locked",
            },
          ]}
        />
        {current === "flexible" ? (
          <Flexible
            onHide={props?.onHide}
            onLoadStart={startLoading}
            onLoadStop={stopLoading}
          />
        ) : (
          <Locked
            onHide={props?.onHide}
            onLoadStart={startLoading}
            onLoadStop={stopLoading}
          />
        )}
      </div>
    </Modal>
  );
}

export default Stake;
